import * as React from 'react';

import { Typography } from '@mui/material';
import { VerticalButtonPanel } from '../subs/ButtonPanel';
import { PageSection } from '../subs/PageSection';
import { WorkshopInfoPanel } from '../subs/WorkshopInfoPanel';
import { Page } from '../subs/Page';
import { ButtonLink } from '../subs/ButtonLink';
import { AlertProps } from '@mui/material/Alert';


import SettingsIcon from '@mui/icons-material/Settings';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Workshop, WorkshopStatus, getWorkshops } from '../types/Workshop';
import { formatDateString } from '../Web';
import { getUserWorkshops } from '../types/User';
import { UserContext } from '../UserProvider';
import { Info } from '../subs/Info';
import { useSnackbar } from '../../contexts/SnackBarContext';

const workshopFilterPredicate = (ws: Workshop) => {
    return ws.status === WorkshopStatus.Testing || ws.status === WorkshopStatus.Registration;
}

export const TestingTab = () => {
    const { showSnackbar } = useSnackbar();
    const debug = false;
    const userContext = React.useContext(UserContext);
    const [workshops, setWorkshops] = React.useState<Workshop[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetch = async () => {
            const sharedAbortController = new AbortController();

            try {
                const userWorkshops = await getUserWorkshops(userContext.user?.id!!, sharedAbortController)
                const workshops = await getWorkshops(sharedAbortController);

                if (workshops.failed) {
                    showUserFeedback(workshops.errorText)
                    return;
                }

                if (userWorkshops.failed) {
                    showUserFeedback(workshops.errorText);
                    return;
                }

                setWorkshops(workshops.result.filter(ws => userWorkshops.result.find(uw => debug || uw.workshopId === ws.id) && workshopFilterPredicate(ws)));
            } catch (error) {
                showUserFeedback(String(error));
                console.log(error);
            }
        }

        fetch();
    }, [userContext, showUserFeedback, debug]);

    return <>
        <Page heading='Testing'>
            <PageSection>
                {[<Typography>
                    {"The Below Workshops are ready for testing."}
                </Typography>]}
                {[<Typography>
                    {"Please find the Workshop you wish to work on and click either 'Configue' to prepare the products for testing, or 'Start Testing' to begin the test process."}
                </Typography>]}
            </PageSection>

            <>{workshops.length > 0 ? workshops.map(workshop =>
                <PageSection heading={workshop.name}>
                    {[<WorkshopInfoPanel location={workshop.location} key={workshop.id}
                        startDate={formatDateString(workshop.startDate) as string}
                        endDate={formatDateString(workshop.endDate) as string}
                        logInfo={workshop.informationUrl}
                        supportMail={workshop.contactEmail} />]}
                    <VerticalButtonPanel heading='Products for testing'>
                        {[<ButtonLink key={`Config${workshop.id}`} fullWidth to={`/WSTesting/${workshop.id}`}
                            startIcon={<SettingsIcon />} disabled={workshop.status === WorkshopStatus.Registration ? false : workshop.status === WorkshopStatus.Testing ? false : true}>
                            Configure (Legacy)
                        </ButtonLink>]}
                    </VerticalButtonPanel>

                    <VerticalButtonPanel>
                        {[<ButtonLink key={`Start${workshop.id}`} fullWidth to={`/wstestingconfig/${workshop.id}`}
                            startIcon={<SettingsIcon />} disabled={workshop.status === WorkshopStatus.Registration ? false : workshop.status === WorkshopStatus.Testing ? false : true}>
                            Configure
                        </ButtonLink>]}
                    </VerticalButtonPanel>

                    <VerticalButtonPanel>
                        {[<ButtonLink key={`Record${workshop.id}`} fullWidth to={`/wstestingrecords/${workshop.id}`}
                            startIcon={<AutorenewIcon />} disabled={workshop.status === WorkshopStatus.Testing ? false : true}>
                            Start testing
                        </ButtonLink>]}
                    </VerticalButtonPanel>
                </PageSection>
            ) : <Info />}</>
        </Page>
    </>
}